module.exports = __webpack_public_path__ + "media/en_au_s1_Daisy.978c45eb.mp3";